import { loadStripe, type Stripe } from "@stripe/stripe-js";

import { publicConfig } from "@/config/public";

/**
 * Load Stripe.js once per page, for every billing surface that needs it.
 *
 * Shared rather than per-component because two module-level caches mean two
 * `Stripe` objects for one page, and because the option below is the kind of
 * detail that gets fixed in one copy and not the other.
 */
let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  const key = publicConfig.stripe.publishableKey;
  if (!key) return Promise.resolve(null);
  if (!stripePromise) {
    stripePromise = loadStripe(key, {
      // Suppress Stripe's floating testing-assistant badge. It only renders
      // against sandbox keys (never in live mode), but it sits on top of our
      // checkout and reads as part of the page.
      developerTools: { assistant: { enabled: false } },
    });
  }
  return stripePromise;
}
